module.exports = "/static/assets/4df6f102bcf57df426152ea842ca629d.png";